"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalStack = exports.StrongOkay = exports.StrongWarning = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("../../../../../../../shared/core");
var StyledStrongWarning = styled_components_1.default.strong(function (_a) {
    var colors = _a.theme.colors;
    return "color: ".concat(colors.warning, ";");
});
var StyledStrongOkay = styled_components_1.default.strong(function (_a) {
    var colors = _a.theme.colors;
    return "color: ".concat(colors.success, ";");
});
var StrongWarning = function (props) {
    var Strong = (0, core_1.useComponents)().Strong;
    return react_1.default.createElement(StyledStrongWarning, __assign({ as: Strong }, props));
};
exports.StrongWarning = StrongWarning;
var StrongOkay = function (props) {
    var Strong = (0, core_1.useComponents)().Strong;
    return react_1.default.createElement(StyledStrongOkay, __assign({ as: Strong }, props));
};
exports.StrongOkay = StrongOkay;
exports.HorizontalStack = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  max-width: 397px;\n\n  > *:first-child {\n    max-width: 50%; /* Prevent from crossing the middle */\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  max-width: 397px;\n\n  > *:first-child {\n    max-width: 50%; /* Prevent from crossing the middle */\n  }\n"])));
var templateObject_1;
